module.exports = __webpack_public_path__ + "static/media/login-bam-logo.e594c207.png";